import { createHttpClient } from '@wix/http-client';

function url(name: string) {
  return `${window.location.protocol}//${window.location.host}/_serverless/feedback-loop-service/${name}`;
}

const isBrowser = typeof window !== 'undefined';

const isDebug = !isBrowser
  ? true
  : ['localhost', '127.0.0.1'].some((host) =>
      window.location.host.startsWith(host),
    ) || new URL(window.location.href).searchParams.get('debug') !== null;

const http = createHttpClient();

export async function shouldShowForm(formId: string) {
  if (isDebug) {
    return true;
  }

  try {
    const response = await http.get<{ shouldShow: boolean }>(
      url('should-show-form'),
      {
        params: {
          formId,
        },
      },
    );

    return response.data.shouldShow;
  } catch (e) {
    return false;
  }
}

export async function notifyFormShown(formId: string) {
  if (isDebug) {
    return;
  }

  try {
    await http.post(url('form-shown'), {
      formId,
    });
  } catch (e: any) {
    throw new Error(
      `feedback-loop: failed to notify form is shown: ${e.message}`,
    );
  }
}
